import React from 'react';
import { FirmTimeIcon } from './firm-time';
import { FlexTimeIcon } from './flex-time';
import { ShareTimeIcon } from './share-time';
import { TimingMode } from '../../entities/timing-mode';

interface IMarkdownTimingIconProps {
  timingMode: TimingMode;
  style?: React.CSSProperties;
  indicatorColor?: string;
  firmTimingTitle: string;
  flexTimingTitle: string;
  shareTimingTitle: string;
}

export const MarkdownTimingIcon: React.FunctionComponent<IMarkdownTimingIconProps> = (props) => {

  return (
    <>
      {props.timingMode === TimingMode.FirmTime && <FirmTimeIcon style={props.style} indicatorColor={props.indicatorColor} title={props.firmTimingTitle} />}
      {props.timingMode === TimingMode.FlexTime && <FlexTimeIcon style={props.style} indicatorColor={props.indicatorColor} title={props.flexTimingTitle} />}
      {props.timingMode === TimingMode.ShareTime && <ShareTimeIcon style={props.style} indicatorColor={props.indicatorColor} title={props.shareTimingTitle} />}
    </>
  );
};
